<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<span *ngIf="visible$ | async">{{ text }}</span>
